import { render, staticRenderFns } from "./onRemoteQuery-editor.vue?vue&type=template&id=41073b4c&scoped=true"
import script from "./onRemoteQuery-editor.vue?vue&type=script&lang=js"
export * from "./onRemoteQuery-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41073b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41073b4c')) {
      api.createRecord('41073b4c', component.options)
    } else {
      api.reload('41073b4c', component.options)
    }
    module.hot.accept("./onRemoteQuery-editor.vue?vue&type=template&id=41073b4c&scoped=true", function () {
      api.rerender('41073b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onRemoteQuery-editor.vue"
export default component.exports